(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-anvil-lp-proof"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (section.dataset.proofReady) return;
      const steps = [...section.querySelectorAll('.c-anvil-lp-proof__step')];
      if (!steps.length) return;
      section.dataset.proofReady = 'true';
      section.classList.add('is-scroll-ready');

      let ticking = false;
      const update = () => {
        ticking = false;
        const middle = window.innerHeight / 2;
        steps.forEach((step) => {
          step.classList.toggle('is-active', step.getBoundingClientRect().top <= middle);
        });
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    };

    const initAll = () => document.querySelectorAll('[data-sl-id="c-anvil-lp-proof"]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-hero-review"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('[data-c-hero-review]');
    
    sections.forEach(section => {
      const isEnabled = section.dataset.judgeMeEnabled === 'true';
      if (!isEnabled) return;
      
      const shopDomain = section.dataset.judgeMeShopDomain;
      const publicKey = section.dataset.judgeMePublicKey;
      const apiUrl = section.dataset.judgeMeApiUrl;
      
      if (!shopDomain || !publicKey) {
        console.warn('[c-hero-review] Missing Judge.me configuration');
        return;
      }

      const ratingEl = section.querySelector('[data-stat-type="rating"] [data-judge-me-rating]');
      const countEl = section.querySelector('[data-stat-type="reviews"] [data-judge-me-count]');

      function formatCompactCount(count) {
        if (count >= 1000000) return Math.round(count / 1000000) + 'M';
        if (count >= 1000) return Math.round(count / 1000) + 'K';
        return String(count);
      }

      if (ratingEl) {
        const ratingUrl = apiUrl + '/widgets/all_reviews_rating?api_token=' + publicKey + '&shop_domain=' + shopDomain;
        fetch(ratingUrl)
          .then(function(res) { return res.json(); })
          .then(function(data) {
            const rating = data.all_reviews_rating !== undefined ? data.all_reviews_rating : data.rating;
            if (typeof rating === 'number') {
              ratingEl.textContent = rating.toFixed(1);
            }
          })
          .catch(function(err) {
            console.warn('[c-hero-review] Judge.me rating fetch failed:', err);
          });
      }

      if (countEl) {
        const countUrl = apiUrl + '/widgets/all_reviews_count?api_token=' + publicKey + '&shop_domain=' + shopDomain;
        fetch(countUrl)
          .then(function(res) { return res.json(); })
          .then(function(data) {
            const count = data.all_reviews_count !== undefined ? data.all_reviews_count : data.count;
            if (typeof count === 'number') {
              countEl.textContent = formatCompactCount(count);
            }
          })
          .catch(function(err) {
            console.warn('[c-hero-review] Judge.me count fetch failed:', err);
          });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-mega-menu"] && !Shopify.designMode) return;
  try {
    
  class MegaMenu {
    constructor() {
      this.activeDropdown = null;
      this.overlay = document.querySelector('[data-menu-overlay]');
      this.mobileOverlay = document.querySelector('[data-mobile-overlay]');
      this.mobileDrawer = document.querySelector('[data-mobile-drawer]');
      this.mobileToggle = document.querySelector('[data-mobile-toggle]');
      this.mobileClose = document.querySelector('[data-mobile-close]');

      this.init();
      this.initScrollDetection();
    }

    init() {
      // Desktop menu triggers - hover behavior
      document.querySelectorAll('[data-menu-trigger]').forEach((trigger) => {
        trigger.addEventListener('mouseenter', (e) => {
          const menuId = trigger.dataset.menuTrigger;
          this.openDropdown(menuId);
        });
      });

      // Keep dropdown open when hovering over nav item
      document.querySelectorAll('.c-mega-menu__nav-item').forEach((item) => {
        item.addEventListener('mouseleave', (e) => {
          // Small delay before closing to allow moving to dropdown
          this.closeTimeout = setTimeout(() => {
            this.closeDropdown();
          }, 100);
        });
      });

      // Keep dropdown open when hovering over the dropdown itself
      document.querySelectorAll('[data-menu-dropdown]').forEach((dropdown) => {
        dropdown.addEventListener('mouseenter', () => {
          clearTimeout(this.closeTimeout);
        });

        dropdown.addEventListener('mouseleave', () => {
          this.closeDropdown();
        });
      });

      // Close on overlay click
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeDropdown());
      }

      // Close mobile drawer on mobile overlay click
      if (this.mobileOverlay) {
        this.mobileOverlay.addEventListener('click', () => this.closeMobileDrawer());
      }

      // Close mobile drawer on close button click
      if (this.mobileClose) {
        this.mobileClose.addEventListener('click', () => this.closeMobileDrawer());
      }

      // Close on ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeDropdown();
          this.closeMobileDrawer();
        }
      });

      // Mobile menu toggle
      if (this.mobileToggle) {
        this.mobileToggle.addEventListener('click', () => {
          this.toggleMobileDrawer();
        });
      }

      // Mobile navigation - navigate to submenu
      document.querySelectorAll('[data-mobile-navigate]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const panelId = trigger.dataset.mobileNavigate;
          this.navigateToPanel(panelId);
        });
      });

      // Mobile navigation - back button
      document.querySelectorAll('[data-mobile-back]').forEach((button) => {
        button.addEventListener('click', () => {
          this.navigateToPanel('main');
        });
      });

      // Close mobile drawer on resize to desktop
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 978) {
          this.closeMobileDrawer();
          this.closeDropdown();
        }
      });

      // Make cards clickeable
      this.initClickableCards();
    }

    initClickableCards() {
      // Handle click on cards with data-card-link attribute
      document.querySelectorAll('[data-card-link]').forEach((card) => {
        card.addEventListener('click', (e) => {
          // Check if the click is on a submenu link or card button
          const isSubmenuLink = e.target.closest('.c-mega-menu__submenu-link');
          const isMobileCardLink = e.target.closest('.c-mega-menu__mobile-card-link');
          const isCardCta = e.target.closest('.c-mega-menu__card-cta');
          const isMobileCardButton = e.target.closest('.c-mega-menu__mobile-card-button');

          // If clicked on a specific link, let it handle naturally
          if (isSubmenuLink || isMobileCardLink || isCardCta || isMobileCardButton) {
            return;
          }

          // Otherwise, navigate to the card's main link
          const cardLink = card.getAttribute('data-card-link');
          if (cardLink) {
            window.location.href = cardLink;
          }
        });
      });
    }

    initScrollDetection() {
      let isScrolled = false;

      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > 0 && !isScrolled) {
          isScrolled = true;
          document.documentElement.style.setProperty('--mega-menu-dropdown-top', '52px');
        } else if (scrollY === 0 && isScrolled) {
          isScrolled = false;
          document.documentElement.style.setProperty('--mega-menu-dropdown-top', '112px');
        }
      });
    }

    openDropdown(menuId) {
      const dropdown = document.querySelector(`[data-menu-dropdown="${menuId}"]`);
      const trigger = document.querySelector(`[data-menu-trigger="${menuId}"]`);

      if (!dropdown) return;

      // If already open, do nothing
      if (this.activeDropdown === dropdown) return;

      // Close previous dropdown and open new one
      this.closeDropdown();
      this.activeDropdown = dropdown;
      dropdown.classList.add('active');
      if (trigger) trigger.classList.add('active');
      this.overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    closeDropdown() {
      clearTimeout(this.closeTimeout);
      if (this.activeDropdown) {
        this.activeDropdown.classList.remove('active');
        // Remove active class from all triggers
        document.querySelectorAll('[data-menu-trigger]').forEach((trigger) => {
          trigger.classList.remove('active');
        });
        this.activeDropdown = null;
      }
      if (this.overlay) {
        this.overlay.classList.remove('active');
      }
      document.body.style.overflow = '';
    }

    toggleMobileDrawer() {
      const isActive = this.mobileDrawer.classList.contains('active');

      if (isActive) {
        this.closeMobileDrawer();
      } else {
        this.mobileDrawer.classList.add('active');
        if (this.mobileOverlay) {
          this.mobileOverlay.classList.add('active');
        }
        this.mobileToggle.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }

    closeMobileDrawer() {
      this.mobileDrawer.classList.remove('active');
      if (this.mobileOverlay) {
        this.mobileOverlay.classList.remove('active');
      }
      this.mobileToggle.classList.remove('active');
      document.body.style.overflow = '';

      // Reset to main panel
      this.navigateToPanel('main');
    }

    navigateToPanel(panelId) {
      // Hide all panels
      document.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
        panel.classList.add('hidden');
      });

      // Show target panel
      const targetPanel = document.querySelector(`[data-mobile-panel="${panelId}"]`);
      if (targetPanel) {
        targetPanel.classList.remove('hidden');
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MegaMenu();
      initializeSwipers();
    });
  } else {
    new MegaMenu();
    initializeSwipers();
  }

  // Initialize Swiper carousels for mega menus with >5 cards
  function initializeSwipers() {
    // Check if Swiper is available (may load with defer)
    if (typeof Swiper === 'undefined') {
      var retryCount = 0;
      var maxRetries = 30;
      var retryInterval = setInterval(function () {
        retryCount++;
        if (typeof Swiper !== 'undefined') {
          clearInterval(retryInterval);
          initSwiper();
        } else if (retryCount >= maxRetries) {
          clearInterval(retryInterval);
        }
      }, 100);
      return;
    }
    initSwiper();
  }

  function initSwiper() {
    // Initialize all swiper containers
    document.querySelectorAll('.c-mega-menu__dropdown-container.swiper').forEach((container) => {
      if (container.swiper) return; // Already initialized
      new Swiper(container, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
          },
          978: {
            spaceBetween: 24,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 32,
            slidesPerView: 4,
          },
        },
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-section-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('[data-section-id]');
    if (!section) return;

    const mediaItems = section.querySelectorAll('.c-section-video__media-item');

    mediaItems.forEach((item) => {
      const playButton = item.querySelector('.c-section-video__play-button');
      const video = item.querySelector('video');

      if (playButton && video) {
        playButton.addEventListener('click', function (e) {
          e.preventDefault();
          if (video.paused) {
            video.play();
            playButton.style.opacity = '0';
          } else {
            video.pause();
            playButton.style.opacity = '1';
          }
        });

        video.addEventListener('play', function () {
          playButton.style.opacity = '0';
        });

        video.addEventListener('pause', function () {
          playButton.style.opacity = '1';
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-value-props"] && !Shopify.designMode) return;
  try {
    
(function () {
  var BREAKPOINT = 768;
  var instances = {};

  function initSection(sectionEl) {
    if (!sectionEl) return;
    var sectionId = sectionEl.getAttribute('data-section-id');
    if (!sectionId || instances[sectionId]) return;

    var swiperEl = sectionEl.querySelector('.c-value-props__swiper');
    var paginationEl = sectionEl.querySelector('.c-value-props__pagination');
    if (!swiperEl) return;

    var swiperInstance = null;

    function createSwiper() {
      if (swiperInstance || typeof Swiper === 'undefined') return;
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });
    }

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function handleResize() {
      if (window.innerWidth < BREAKPOINT) {
        createSwiper();
      } else {
        destroySwiper();
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);

    instances[sectionId] = {
      destroy: function () {
        destroySwiper();
        window.removeEventListener('resize', handleResize);
        delete instances[sectionId];
      },
    };
  }

  function initAll() {
    document.querySelectorAll('.c-value-props').forEach(function (el) {
      initSection(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (!section.classList.contains('c-value-props')) {
      section = section.querySelector('.c-value-props');
    }
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sectionId = e.detail.sectionId;
    if (instances[sectionId]) {
      instances[sectionId].destroy();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
